import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import i18n from "i18next";

import type { Lang } from "@/i18n/languages";
import { LangProvider } from "@/hooks/useLang";

export default function LangLayout({ lang }: { lang: Lang }) {
  useEffect(() => {
    document.documentElement.lang = lang;
    i18n.changeLanguage(lang);
  }, [lang]);

  return (
    <LangProvider lang={lang}>
      <Outlet />
    </LangProvider>
  );
}
